import React from 'react';
import { Link } from 'react-router-dom';
import { Panel, PanelEmpty, rowClass } from './Panel';
import { cityFromAddress, dayAndMonth, dayDiff, relativeUpcoming, timeOf } from '../../../utils/adminDates';
import type { Case } from '../../../types/admin';
export function UpcomingPanel({
  cases
}: {
  cases: Case[];
}) {
  return <Panel title="Kommende opgaver" linkLabel="Se kalender" linkTo="/admin/kalender" data-id="element-376" data-mp="20eiesgyony6u">
      {cases.length === 0 ? <PanelEmpty data-id="element-377" data-mp="2x2oqtoxxpsv5">Ingen planlagte opgaver endnu.</PanelEmpty> : <ul className="divide-y divide-line/70" data-id="element-378" data-mp="2s5ol5f4zys4k">
          {cases.map(item => {
        const date = dayAndMonth(item.plannedDate);
        const time = timeOf(item.plannedDate);
        const soon = (dayDiff(item.plannedDate) ?? 99) <= 1;
        return <li key={item.id} data-id="element-379" data-mp="1co62ktwenfag">
                <Link to={`/admin/sager/${item.id}`} className={rowClass} data-id="element-380" data-mp="1cp7mlnvefc4b">
                  <span className="flex h-12 w-12 shrink-0 flex-col items-center justify-center rounded-lg border border-line bg-canvas leading-none" data-id="element-381" data-mp="17nib6749kwfp">
                    <span className="font-display text-lg font-bold text-ink" data-id="element-382" data-mp="3cadrbbjjvuif">{date?.day}</span>
                    <span className="mt-0.5 text-[11px] text-ink-muted" data-id="element-383" data-mp="3h8xdnd2238bb">{date?.month}</span>
                  </span>
                  {time && <span className="hidden w-12 shrink-0 text-sm text-ink-soft sm:block" data-id="element-384" data-mp="38ad16tn39uvj">{time}</span>}
                  <span className="min-w-0 flex-1" data-id="element-385" data-mp="2tl7358zzmap8">
                    <span className="block truncate text-[15px] font-semibold text-ink" data-id="element-386" data-mp="2tke6j0uqt1kt">{item.title}</span>
                    <span className="block truncate text-sm text-ink-muted" data-id="element-387" data-mp="2yeicbgs9v3kb">
                      {[item.customerName, cityFromAddress(item.address)].filter(Boolean).join(' · ')}
                    </span>
                  </span>
                  <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-medium ${soon ? 'border-status-ok/40 bg-status-ok/10 text-status-ok' : 'border-line bg-canvas-deep text-ink-soft'}`} data-id="element-388" data-mp="2an4lxgdoli1z">
                    {relativeUpcoming(item.plannedDate)}
                  </span>
                </Link>
              </li>;
      })}
        </ul>}
    </Panel>;
}